
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";
import { SearchTextField } from "../../components/SearchTextField";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { ActualizarSala, AgregarSala, Sala } from "../../connections/catalogos/SalaConnection";

import { SalaProps } from "../../interfaces/catalogos/SalaInterface";

export const SalaPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [salaArray, setSalaArray] = useState<SalaProps[]>( [] );
 
    const [openModal, setOpenModal] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idSala, setIdSala] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( salaArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( activo: boolean, tradicional: boolean, id: number ) => {

        const salaSelected = salaArray.find( ( elem ) => elem.idSala === id );

        if( salaSelected ){

            await ActualizarSala({ ...salaSelected, activo, tradicional, }).then( resp => {
                
                if( resp.idSala ){

                    var newArray = salaArray.map( ( elem ) => {

                    if( elem.idSala === id ){
                        elem.activo = activo;
                        elem.tradicional = tradicional;
                    }
            
                        return elem;
                    });
            
                    setSalaArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idSala !== 0 ){

            const salaSelected = salaArray.find( ( elem ) => elem.idSala === idSala );

            if( salaSelected ){

                setLoading( true );
    
                await ActualizarSala({ ...salaSelected, descripcion, }).then( resp => {
                    
                    if( resp.idSala ){

                        setTimeout(() => {
                            
                            var newArray = salaArray.map( ( elem ) => {
        
                                if( elem.idSala === idSala ){
                                    elem.descripcion = descripcion;
                                }
                        
                                return elem;
                            });
                    
                            setSalaArray( newArray );
                            setOpenModal( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 
                            
                        }, 700);
    
                    }    
        
                });
            }       
    

        }
        else {

            const SalaAdd: SalaProps = {
                idSala: 0,
                descripcion,       
                tradicional: false,        
                activo: true,
            }

            setLoading( true );

            await AgregarSala( SalaAdd ).then( resp => {
                    
                if( resp.idSala ){                
            
                    setTimeout(() => {
                        
                        setSalaArray([ ...salaArray, resp ]);
                        setOpenModal( false );
                        setLoading( false );
                        
                        dispatch( openSnackbar({ message: 'Se agregó la sala correctamente', variant: 'success' })); 

                    }, 700);

                }    
    
            });

        }

    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setSalaArray( [] );

            await Sala().then( resp => {

                setTimeout(() => {
                    
                    setSalaArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])    

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Sala' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >  
                
                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button startIcon={ <UndoIcon /> } variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button                       
                        variant="contained" 
                        sx={{ mt: 1 }} 
                        disabled={ loadingData }
                        onClick={ () => {
                            
                            setIdSala( 0 );
                            setDescripcion( '' );

                            setOpenModal( true );
                        }}
                    > 
                        Agregar
                    </Button> 

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar por descripción"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '55%' }}> Descripción </TableCell>                                   
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Sala <br /> Tradicional </TableCell>                                   
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( { idSala, descripcion, tradicional, activo } ) => (

                                <TableRow key={ idSala } >
                                
                                    <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        { idSala }
                                    </TableCell>                                 

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>      
                  
                                    <TableCell sx={{ textAlign: 'center' }}>
                                        <Switch 
                                            checked={ tradicional } 
                                            onChange={ ( e ) => handleChangeChecked( activo, e.target.checked, idSala ) }
                                        />     
                                    </TableCell>      
    
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, tradicional, idSala ) }
                                        />                                            
                           
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdSala( idSala );
                                                    setDescripcion( descripcion );                                                   

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  

                                    </TableCell>

                                </TableRow>

                            ))
                        }                    
            
                        { 
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 53 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" fontWeight={'bold'}> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={1} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>
                        }

                    </TableFooter>
                    
                </Table>
                
            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
            
                <DialogContent>
                       
                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción'}
                        variant="outlined"                           
                        multiline
                        rows={4}                                        
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                    /> 

                </DialogContent>

                <DialogActions>
                    <Button color="secondary" disabled={ loading } onClick={ () => { setOpenModal( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained' startIcon={ <SaveIcon /> } > Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}